import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkboxesValidator =
  (minRequired = 1): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    return control.value.length < minRequired ? { checkboxes: true } : null;
  };
